import { List, ShowButton, TextField } from "@refinedev/antd";
import { useNavigation } from "@refinedev/core";
import { Space, Table } from "antd";
import { AppTitle } from "components";

type MedicinePage = {
  id: string;
  title: string;
  path: string;
};

const medicinePages: MedicinePage[] = [
  {
    id: "section",
    title: "Главный блок медицины",
    path: "/medicine/section",
  },
  {
    id: "contests",
    title: "Конкурс",
    path: "/medicine/contests",
  },
  {
    id: "conferences",
    title: "Конференции",
    path: "/medicine/conferences",
  },
  {
    id: "materials",
    title: "Полезные материалы по медицине",
    path: "/medicine/materials",
  },
  {
    id: "anti-doping-materials",
    title: "Антидопинг материалы",
    path: "/medicine/anti-doping/materials",
  },
];

export const MedicineList = () => {
  const { push } = useNavigation();

  return (
    <List
      title={<AppTitle canGoBack>Медицина</AppTitle>}
      resource="medicine"
      breadcrumb={false}
      canCreate={false}
      headerButtons={false}
    >
      <Table<MedicinePage>
        dataSource={medicinePages}
        rowKey="id"
        pagination={false}
        locale={{
          emptyText: <div style={{ margin: 56 }}>Страницы отсутствуют</div>,
        }}
      >
        <Table.Column<MedicinePage>
          dataIndex="title"
          key="title"
          title="Страница"
          render={(value) => <TextField value={value} />}
        />
        <Table.Column<MedicinePage>
          width={260}
          fixed="right"
          key="actions"
          title="Действия"
          render={(_, record) => (
            <Space size={8} direction="vertical" style={{ width: "100%" }}>
              <ShowButton onClick={() => push(record.path)} size="small" block>
                Смотреть / Редактировать
              </ShowButton>
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
